import React, { useEffect, useState } from 'react'
import { EventEmitter } from '../../utils/EventEmitter';

const logoAltText = window.__env.LOGO_ALT_TEXT || "Alida Platform";

type Props = {
  height?: string | number;
  width?: string | number;
  className?: string;
  greyScale?: boolean;
}

export default function Logo({ height, className, width, greyScale }: Props) {
  const [timestamp, setTimestamp] = useState(new Date().getTime());

  useEffect(() => {
    EventEmitter.subscribe('update-timestamp', (ts: number) => setTimestamp(ts));
  }, []);

  return (
    <img
      alt={logoAltText}
      src={(greyScale ? window.__env.GREY_LOGO_URL : window.__env.LOGO_URL) + `?t=${timestamp}`}
      height={height}
      width={width}
      className={className}
    />
  )
}
